import React, { FC, Fragment } from 'react';
import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import LinkGroup from './LinkGroup';
import MarkGroup from './MarkGroup';
import BlockGroup from './BlockGroup';
import EmojiGroup from './EmojiGroup';

const useStyles = makeStyles(theme => ({
  divider: {
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
    backgroundColor: theme.palette.grey[400],
  },
}));

const Toolbar: FC = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <Divider className={classes.divider} />
      <MarkGroup />
      <BlockGroup />
      <LinkGroup />
      <EmojiGroup />
    </Fragment>
  );
};

export default Toolbar;
